import React from "react";
import "./Card.css";
import CardImage1 from "../../assets/CardImage1.avif";
import CardImage2 from "../../assets/CardImage2.avif";
import CardImage3 from "../../assets/CardImage3.avif";

const Card = () => {
  return (
    <div className="card grid">
      <div className="cardImage flex column cursorPointer">
        <img src={CardImage1} alt="Order Online" className="cardImage1" />
        <p className="cardHeading">Order Online</p>
        <p className="cardDescription">Stay home and order to your doorstep</p>
      </div>
      <div className="cardImage flex column cursorPointer">
        <img src={CardImage2} alt="Dining" className="cardImage2" />
        <p className="cardHeading">Dining</p>
        <p className="cardDescription">
          View the city's favourite dining venues
        </p>
      </div>
      <div className="cardImage flex column cursorPointer">
        <img
          src={CardImage3}
          alt="Nightlife and Clubs"
          className="cardImage3"
        />
        <p className="cardHeading">Nightlife and Clubs</p>
        <p className="cardDescription">
          Explore the city’s top nightlife outlets
        </p>
      </div>
    </div>
  );
};

export default Card;
